import { EntityCode } from '../../../types/entityCodeTypes';
import { UserTypes } from '../types/changeContactService';
import { ContactInfoStatusType } from '../types/changeContactService';

// customerResetUserName
export const RESET_USER_NAME_EMAIL_TYPE = 'email';
export const RESET_USER_NAME_MOBILE_TYPE = 'mobile';

//customerResetUNOrPWC
export const RESET_USER_NAME_KEY = 'userName';
export const RESET_PASSWORD_KEY = 'password';
export const featureNameMap: { [prop: string]: string } = {
  RESET_USER_NAME_KEY: 'updateUsername',
  RESET_PASSWORD_KEY: 'updatePassword',
};

//customerProfile
export const SLIDER_ITEM_WIDTH = 180;
export const SLIDER_ITEM_OFFSET_WIDTH = 196;
export const CHANGE_CONTACT_ID = 'changeContact';
export const LIFE_REGEX = /^(LMA|LHK)/;
export const UPDATE_MOBILE_LOB_REGEX = /^(LHK|G4HK|GHK)/;

//longLoading
export const POLICIES = 5;

//featureName
export const FEATURE_NAME_USER_NAME = 'updateUsername';
export const FEATURE_NAME_PASSWORD = 'updatePassword';

// default error code
export const RESET_USER_NAME_EMAIL_DEFAULT_ERROR_CODE = 'CICER11';
export const RESET_USER_NAME_MOBILE_DEFAULT_ERROR_CODE = 'CICER11';
export const RESET_PASSWORD_DEFAULT_ERROR_CODE = 'CICER12';
export const EDIT_MAIL_NUMBER_DEFAULT_ERROR_CODE = 'CICER05';
export const EDIT_MOBILE_NUMBER_DEFAULT_ERROR_CODE = 'CICER06';

export const VERIFY_DISPLAY_ERROR_CODE_LIST = ['Error01', 'Error02'];

export const UPDATE_MAIL_NUMBER_OR_MOBILE_DEFAULT_ERROR_CODE = 'CICER07';
export const MAIL_OR_MOBILE_SUBMISSION_DEFAULT_ERROR_CODE = 'CICER07';
export const ADDRESS_SUBMISSION_DEFAULT_ERROR_CODE = 'CICER07';

export const VERIFY_SEND_EMAIL_OTP_DEFAULT_ERROR_CODE = 'CICER05';
export const VERIFY_SEND_MOBILE_OTP_DEFAULT_ERROR_CODE = 'CICER06';

// cic feature id
export const UPDATE_EMAIL_FEATURE_ID = 'update_email';
export const UPDATE_MOBILE_FEATURE_ID = 'update_mobile';
export const UPDATE_ADDRESS_FEATURE_ID = 'update_address';
export const RESET_USERNAME_EMAIL_FEATURE_ID = 'reset_username_email';
export const RESET_PASSWORD_EMAIL_FEATURE_ID = 'reset_password_email';
export const RESET_USERNAME_MOBILE_FEATURE_ID = 'reset_username_mobile';

export const RESET_USERNAME_FEATURE_ID = 'reset_username';
export const RESET_PASSWORD_FEATURE_ID = 'reset_password';

export const UserTypeCodes: {
  [key in EntityCode]: UserTypes;
} = {
  LHK: 'Life',
  LMA: 'Life',
  EHK: 'EB',
  GHK: 'P&C',
  G4HK: 'FirstCare',
};

type StatusKeyType = 'VALID' | 'UPDATING' | 'EMPTY' | 'INVALID';

export const ContactInfoStatuses: {
  [key in StatusKeyType]: ContactInfoStatusType;
} = {
  VALID: 'valid',
  UPDATING: 'updating',
  EMPTY: 'empty',
  INVALID: 'invalid',
};

// cic addressCase
export const ENGLISH_ADDRESS_CASE = 'englishAddress';
export const CHINESE_ADDRESS_CASE = 'chineseAddress';
export const INVALID_ADDRESS_CASE = 'invalidAddress';

export const ADDRESS_DEFAULT_VALUE = {
  addrLine1: '',
  addrLine2: '',
  addrLine3: '',
  addrLine4: '',
};

export const ADDRESS_ERROR_CICER21 = 'CICER21';
export const ADDRESS_ERROR_CICER22 = 'CICER22';
export const ADDRESS_ERROR_CICER23 = 'CICER23';
export const ADDRESS_ERROR_CICER24 = 'CICER24';
export const ADDRESS_ERROR_CICER25 = 'CICER25';
export const ADDRESS_HK_ENG = 'hkEngAddress';

export const HAPPY_HK_CASE = 'happyHKCase';
